import script from "./DownloadAppButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadAppButton.vue?vue&type=script&setup=true&lang=js"

import "./DownloadAppButton.vue?vue&type=style&index=0&id=590c5cd9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-590c5cd9"]])

export default __exports__